import { useEffect, useMemo, useState } from "react";
import { ToastService } from "../../../shared/bootstrap/Toast";
import { ImportTemplateListResponse } from "../../../shared/entities/ImportTemplateListResponse";
import { TranslationService } from '../../../../services/TranslationService';
import { TemplateField } from "./ImportTemplateEditBase";

import ImportTemplateService from "../../../../services/ImportTemplateService";
import FloatingPanelService from "../../../shared/FloatingPanel";
import { RequiredManager } from "../../../shared/RequieredManager";
import { FloatingPanelFooter } from "../../../shared/components/FloatingPanelFooter";
import { InvoiceFields } from "../../../../services/InvoiceService";
import { ClientExportField, ClientFields } from "../../../../services/ClientService";
import Loading from "../../../shared/components/Loading";
import { handleErrorWithToast } from "../../../../utils/RequestUtils";
import ModalService from "../../../shared/bootstrap/Modal";
import FieldSelectColumnList from "./Components/FieldSelectColumnList";
import { ImportExportGetResponse } from "../../../../entities/import/ImportExportGet";
import { Entities } from "../../../../services/CompanyService";

const ImportTemplateEditClientExportTemplate = ({ data, reload, importsList = undefined, entityId = undefined }: { data?: ImportTemplateListResponse.Item, reload: () => void, importsList?: ImportTemplateListResponse, entityId?: number }) => {
    const { translate } = TranslationService;
    const [loading, setLoading] = useState(true);
    const [submiting, setSubmiting] = useState(false);
    const requiredManager = useMemo(() => new RequiredManager(), []);
    const [model, setModel] = useState<Partial<ImportExportGetResponse.Item>>(() => ({ Sheet: "num-1", Entity: entityId!, entity: entityId! }));

    const Header = () => (
        <div className="mx-4 mt-4 d-flex align-items-center justify-content-between">
            <h5>{translate.ConfigureAutomaticClientUpdateProcess} </h5>
        </div>
    );

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            const result = await handleErrorWithToast(ImportTemplateService.getExportTemplate(data!.ImportTemplateID));

            const columnsModel = result.list.map((rl: ImportExportGetResponse.Item) => {
                const name = rl.AdditionalDefinition ? "additional-" + rl.AdditionalDefinitionID : rl.Field?.toString();
                const ix = rl.Position;
                return { ix, name, pattern: "" }
            })
            setModel(x => ({ ...x, Columns: [...columnsModel] }))
            setLoading(false);
        };
        getData();
    }, [data])

    const onSubmit = async () => {
        if (submiting) {
            return;
        }
        setSubmiting(true);

        const list = (model as any).Columns
            .filter((c: ImportTemplateListResponse.Column) => c.ix)
            .map((mc: any) => {
                const isAdditional = mc.name.toString().includes('additional');

                if (isAdditional) {
                    return ({
                        Field: mc.name.toString().replace('additional-', ""),
                        Position: mc.ix,
                        Entity: 0,
                    })
                }

                if (mc.name < 0) {
                    return ({
                        Field: mc.name,
                        Position: parseInt(mc.ix),
                        Entity: 0,
                    })
                }

                return ({
                    Field: ClientExportField[mc.name] || ClientFields[mc.name] || InvoiceFields[mc.name] || mc.name,
                    Position: parseInt(mc.ix),
                    Entity: 0,
                })
            })

        const result = await ImportTemplateService.setExportTemplate(data!.ImportTemplateID, list);
        if (result instanceof Error) {
            ToastService.showToast(translate.ErrorProcessingRequest, undefined, "danger");
            return;
        }

        ToastService.showToast(translate.ImportTemplateSaved, undefined, "success");
        setSubmiting(false);
        reload();
        FloatingPanelService.hidePanel();
    }

    const clientFields: TemplateField[] = useMemo(() => {
        if (entityId !== undefined || (entityId)) {
            const resultFields = ImportTemplateService.getExportTemplateFields(Entities.Client);
            ModalService.hideModal();
            return resultFields;
        } else {
            return [];
        }
    }, [entityId]);

    const invoiceFields: TemplateField[] = useMemo(() => {
        if (entityId !== undefined || (entityId)) {
            const resultFields = ImportTemplateService.getExportTemplateFields(Entities.Invoice);
            ModalService.hideModal();
            return resultFields;
        } else {
            return [];
        }
    }, [entityId]);

    if (loading) {
        return <Loading />
    }
    return (
        <>
            <Header />
            <div className="floatingBody p-4">
                <FieldSelectColumnList
                    model={model}
                    setModel={setModel}
                    clientFields={clientFields}
                    invoiceFields={invoiceFields}
                    requiredFieldIds={clientFields.filter(x => x.required).map(x => x.fieldId)}
                    requiredManager={requiredManager}
                />
            </div>
            <FloatingPanelFooter>
                <button className='btn btn-primary' onClick={onSubmit}>
                    {translate.Save}
                    {submiting && <i className="fas fa-spinner-third fa-spin third ms-2"></i>}
                </button>
            </FloatingPanelFooter>
        </>
    )
}
export default ImportTemplateEditClientExportTemplate;
